import { render, staticRenderFns } from "./print.vue?vue&type=template&id=24cd8601&scoped=true&"
import script from "./print.vue?vue&type=script&lang=js&"
export * from "./print.vue?vue&type=script&lang=js&"
import style0 from "./print.vue?vue&type=style&index=0&id=24cd8601&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cd8601",
  null
  
)

export default component.exports